// Auto-generated by scripts/build.js — do not edit by hand.
const version = '3.0.2-1007';
export default version;
